import { useList, useCreate, useUpdate, useDetail, fetchApi, useDelete } from "@inmagik/react-crud"
import { Opera } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useOpereList(params: Record<string, string> = {}) {
  return useList<Opera>(`${API_URL}/admin/opere`, {
    query: params,
  })
}

export function useOperaCreate() {
  return useCreate<Opera>(`${API_URL}/admin/opere`)
}

export function useOperaUpdate(id: number) {
  return useUpdate<Opera>(`${API_URL}/admin/opere`)
}

export function useOpera(id: number | undefined) {
  return useDetail<Opera>(`${API_URL}/admin/opere`, id?.toString())
}

export function useOperaLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/opere/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Opera>
  }, [])
}

export function useOpereLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/opere?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Opera[] }>
  }, [])
}

export function useOperaDelete() {
  return useDelete(`${API_URL}/admin/opere`)
}
